import { Injectable, inject } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { filter, Observable } from 'rxjs';
import { ProductSearchPage } from '@boels/models';
import { map } from 'rxjs/operators';
import { loadGlobalProductSearchPage } from '../actions/global-product-search.action';
import {
  selectGlobalProductSearchPageState,
  selectGlobalProductSearchPageTotalResults,
} from '../selectors/global-product-search.selector';
import { GlobalProductSearchState } from '../reducers/global-product-search.reducer';

@Injectable()
export class GlobalProductSearchFacade {
  protected store = inject<Store<GlobalProductSearchState>>(Store);

  getGlobalProductsSearch(
    query: string,
    pageSize = 12,
    currentPage: number,
    sortCode?: string,
  ): Observable<ProductSearchPage | undefined> {
    this.store.dispatch(
      loadGlobalProductSearchPage({ query, pageSize, currentPage, sortCode }),
    );
    return this.store.pipe(
      select(selectGlobalProductSearchPageState),
      filter(
        (productSearchState: GlobalProductSearchState) =>
          !productSearchState.loading,
      ),
      map((productSearchPage) => productSearchPage.entities),
    );
  }

  getGlobalProductSearchPageLoading(): Observable<boolean> {
    return this.store.pipe(
      select(selectGlobalProductSearchPageState),
      map((val) => val.loading),
    );
  }

  getGlobalProductSearchPageTotalResults(): Observable<number | undefined> {
    return this.store.pipe(
      select(selectGlobalProductSearchPageTotalResults),
      map((val) => val),
    );
  }
}
